export default [
  {
    path: "user",
    name: "用户管理",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/userCenter/user.vue"),
    meta: {
      title: "用户管理",
      keepAlive: true,
    },
  },
  {
    path: "post",
    name: "岗位管理",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/userCenter/post.vue"),
    meta: {
      title: "岗位管理",
      keepAlive: true,
    },
  },
  {
    path: "role",
    name: "角色管理",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/userCenter/role.vue"),
    meta: {
      title: "角色管理",
      keepAlive: true,
    },
  },
  {
    path: "dept",
    name: "部门管理",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/userCenter/dept.vue"),
    meta: {
      title: "部门管理",
      keepAlive: true,
    },
  },
  {
    path: "menu",
    name: "菜单管理",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/userCenter/menu.vue"),
    meta: {
      title: "菜单管理",
      keepAlive: true,
    },
  },
  {
    path: "dictType",
    name: "字典类型",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/userCenter/dictType.vue"),
    meta: {
      title: "字典类型",
      keepAlive: true,
    },
  },
  {
    path: "dictData",
    name: "字典数据",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/userCenter/dictData.vue"),
    meta: {
      title: "字典数据",
      keepAlive: true,
    },
  },
  {
    path: "unionScreen",
    name: "水务大脑大屏",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/userCenter/unionScreen.vue"),
    meta: {
      title: "水务大脑大屏",
      keepAlive: true,
    },
  },
];
